// extracted by mini-css-extract-plugin
module.exports = {"--space-2x":"16px","space2X":"16px","root":"root-2kEvdOnj2r","section":"section-3DLVG4E_1z"};